"use client"
import React, { useEffect } from "react"
import { Progress } from "@/components/ui/progress"
import { useAppSelector } from "@/app/redux/hooks/reduxHooks"

export const SeasonMeterComponent = () => {
    const seasonPass = useAppSelector((state) => state.auth.seasonPass)
    const bronze = useAppSelector((state) => state.dashboard.bronzeTier)
    const silver = useAppSelector((state) => state.dashboard.silverTier)
    const gold = useAppSelector((state) => state.dashboard.goldTier)
    const rank = useAppSelector((state) => state.dashboard.rank)
    const nextRank = useAppSelector((state) => state.dashboard.nextRank)

    const calculateMeterValue = () => {
        switch (rank) {
            case "Unranked":
                return (seasonPass! / bronze!) * 100
            case "Bronze":
                return (seasonPass! / silver!) * 100
            case "Silver":
                return (seasonPass! / gold!) * 100
            case "Gold":
                return 100
        }
    }

    useEffect(() => {
        calculateMeterValue()
    }, [seasonPass])

    return (
        <div className="h-[38px] mt-5 sm:mt-0">
            <div className="flex">
                <div className="flex-grow">
                    <h3 className="font-thin text-[12px]">Season Progress</h3>
                </div>
                <div>
                    <h3 className="font-thin text-[12px]">{nextRank}</h3>
                </div>
            </div>
            <Progress value={calculateMeterValue() ?? 0} className="border border-[#222] h-[5px]" />
        </div>
    )
}
